import { Page } from "@/components/common/Page";
import { useCallback, useState } from "react";
import { ScheduledJob } from "@/types/common.types";
import { useNavigate } from "react-router-dom";
import InsightList from "./InsightList";
import InsightDetailForJob from "./InsightDetailForJob";
import InsightDetailForJobByDate from "./InsightDetailForJobByDate";

const Insights = () => {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState<ScheduledJob | null>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const onSelectJob = useCallback((job: ScheduledJob) => {
    setSelectedJob(job);
  }, []);
  const onClearSelectedJob = useCallback(() => {
    setSelectedJob(null);
  }, []);
  const onSelectDate = useCallback((date: string) => {
    setSelectedDate(date);
  }, []);
  const onCreateJob = useCallback(() => {
    navigate("/upload");
  }, [navigate]);

  const renderContent = () => {
    if (selectedDate && selectedJob) {
      return (
        <InsightDetailForJobByDate
          date={selectedDate as string}
          onBack={() => setSelectedDate(null)}
          job={selectedJob}
        />
      );
    }

    if (selectedJob) {
      return (
        <InsightDetailForJob
          job={selectedJob}
          onBack={onClearSelectedJob}
          onDateClick={onSelectDate}
        />
      );
    }

    return <InsightList onSelectJob={onSelectJob} onCreateJob={onCreateJob} />;
  };
  return (
    <Page className="overflow-x-scroll">{renderContent()}</Page>
  );
};

export default Insights;
